import React from 'react';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&family=DM+Serif+Display&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  :root {
    --bg: #eef1f7;
    --surface: #ffffff;
    --text-dark: #1a2340;
    --text-body: #4a5568;
    --text-muted: #718096;
    --accent: #4a6fa5;
    --accent-light: #6b8fc4;
    --border: #dde3ee;
    --step1: #2d4a8a;
    --step2: #c97b2e;
    --step3: #5a9e6f;
  }

  body {
    font-family: 'DM Sans', sans-serif;
    background: var(--bg);
    color: var(--text-body);
    min-height: 100vh;
  }

  .pp-page-wrapper {
    max-width: 860px;
    margin: 0 auto;
    padding: 56px 24px 80px;
  }

  .pp-hero {
    background: var(--surface);
    border-radius: 16px;
    padding: 40px 48px;
    margin-bottom: 32px;
    border: 1px solid var(--border);
    display: flex;
    align-items: flex-start;
    gap: 32px;
  }

  .pp-hero-icon {
    width: 56px;
    height: 56px;
    background: linear-gradient(135deg, #2d4a8a 0%, #4a6fa5 100%);
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .pp-hero-icon svg { width: 26px; height: 26px; fill: white; }

  .pp-hero-text h1 {
    font-family: 'DM Serif Display', serif;
    font-size: 2rem;
    color: var(--text-dark);
    line-height: 1.2;
    margin-bottom: 10px;
    letter-spacing: -0.02em;
  }

  .pp-hero-meta {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
  }

  .pp-meta-pill {
    font-size: 0.78rem;
    font-weight: 500;
    color: var(--text-muted);
    background: var(--bg);
    border: 1px solid var(--border);
    padding: 4px 12px;
    border-radius: 20px;
  }

  .pp-content-card {
    background: var(--surface);
    border-radius: 16px;
    border: 1px solid var(--border);
    overflow: hidden;
  }

  .pp-toc-bar {
    background: #f7f9fd;
    border-bottom: 1px solid var(--border);
    padding: 16px 40px;
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    align-items: center;
  }

  .pp-toc-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-right: 4px;
  }

  .pp-toc-link {
    font-size: 0.78rem;
    color: var(--accent);
    text-decoration: none;
    background: white;
    border: 1px solid var(--border);
    padding: 4px 10px;
    border-radius: 6px;
    transition: background 0.15s, color 0.15s;
  }
  .pp-toc-link:hover {
    background: var(--accent);
    color: white;
    border-color: var(--accent);
  }

  .pp-policy-body {
    padding: 40px 48px 48px;
  }

  .pp-section {
    margin-bottom: 44px;
    scroll-margin-top: 80px;
  }

  .pp-section-header {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 20px;
  }

  .pp-section-number {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: linear-gradient(135deg, #2d4a8a 0%, #4a6fa5 100%);
    color: white;
    font-size: 0.8rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .pp-section-title {
    font-family: 'DM Serif Display', serif;
    font-size: 1.2rem;
    color: var(--text-dark);
    letter-spacing: -0.01em;
  }

  .pp-clause {
    margin-bottom: 16px;
    padding: 16px 20px;
    background: #f9fafd;
    border-radius: 10px;
    border-left: 3px solid var(--border);
    transition: border-color 0.2s;
  }
  .pp-clause:hover { border-left-color: var(--accent-light); }

  .pp-clause-label {
    font-size: 0.72rem;
    font-weight: 700;
    color: var(--accent);
    text-transform: uppercase;
    letter-spacing: 0.08em;
    margin-bottom: 6px;
  }

  .pp-clause p {
    font-size: 0.92rem;
    line-height: 1.7;
    color: var(--text-body);
  }

  .pp-clause ul {
    list-style: none;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .pp-clause ul li {
    font-size: 0.9rem;
    color: var(--text-body);
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .pp-clause ul li::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--accent);
    flex-shrink: 0;
  }

  .pp-contact-card {
    background: linear-gradient(135deg, #eef2fa 0%, #e8eef8 100%);
    border-radius: 12px;
    padding: 24px 28px;
    border: 1px solid #d4ddf0;
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
  }

  .pp-contact-avatar {
    width: 48px;
    height: 48px;
    background: linear-gradient(135deg, #2d4a8a, #6b8fc4);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 1.1rem;
    font-weight: 700;
    flex-shrink: 0;
  }

  .pp-contact-info .pp-name {
    font-weight: 600;
    font-size: 0.95rem;
    color: var(--text-dark);
    margin-bottom: 2px;
  }

  .pp-contact-info .pp-role {
    font-size: 0.8rem;
    color: var(--text-muted);
    margin-bottom: 6px;
  }

  .pp-contact-info a {
    font-size: 0.85rem;
    color: var(--accent);
    text-decoration: none;
    font-weight: 500;
  }
  .pp-contact-info a:hover { text-decoration: underline; }

  .pp-section-divider {
    border: none;
    border-top: 1px solid var(--border);
    margin: 32px 0;
  }

  .pp-footer-strip {
    background: var(--surface);
    border-top: 1px solid var(--border);
    padding: 20px 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 32px;
    border-radius: 16px;
    border: 1px solid var(--border);
  }

  .pp-footer-strip p {
    font-size: 0.78rem;
    color: var(--text-muted);
  }

  .pp-back-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 0.82rem;
    font-weight: 600;
    color: var(--accent);
    text-decoration: none;
    background: var(--bg);
    border: 1px solid var(--border);
    padding: 8px 16px;
    border-radius: 8px;
    transition: background 0.15s;
  }
  .pp-back-btn:hover { background: #dde3f0; }

  .pp-intro-clause {
    border-left-color: var(--accent);
    margin-bottom: 32px;
  }

  @media (max-width: 600px) {
    .pp-hero { flex-direction: column; padding: 28px 24px; }
    .pp-policy-body { padding: 28px 24px; }
    .pp-toc-bar { padding: 14px 24px; }
  }
`;

export default function Privacy({ embedded = false }) {
  const legalStyles = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
    :root { --bg:#EEF2FA; --surface:#FFFFFF; --surface-muted:#F7F9FC; --border:#D4DEEF; --border-light:#E8EDF6; --text:#1B2540; --text-muted:#5A6785; --text-dimmed:#8C96AB; --primary:#4472C4; --primary-light:#E2EAFB; --radius-md:12px; --radius-lg:16px; --shadow-sm:0 1px 3px rgba(30,50,100,0.06),0 1px 2px rgba(30,50,100,0.04); --font-display:'Plus Jakarta Sans',-apple-system,sans-serif; --font-body:'DM Sans',-apple-system,sans-serif; }
    *,*::before,*::after{margin:0;padding:0;box-sizing:border-box;}
    body{font-family:var(--font-body);background:var(--bg);color:var(--text);min-height:100vh;}
    .legal-page{max-width:760px;margin:0 auto;padding:26px 18px 42px;}
    .legal-shell{background:var(--surface);border:1px solid var(--border);border-radius:var(--radius-lg);box-shadow:var(--shadow-sm);overflow:hidden;}
    .legal-head{display:flex;align-items:center;justify-content:space-between;padding:18px 22px 14px;border-bottom:1px solid var(--border-light);background:linear-gradient(180deg,var(--surface) 0%,var(--surface-muted) 100%);}
    .legal-head h1{font-family:var(--font-display);font-size:1.1rem;font-weight:800;color:var(--text);letter-spacing:-0.02em;}
    .legal-body{padding:18px 22px 26px;text-align:left;}
    .legal-meta{display:flex;align-items:center;gap:8px;margin-bottom:16px;padding-bottom:14px;border-bottom:1px solid var(--border-light);}
    .legal-meta-badge{display:inline-flex;align-items:center;gap:5px;padding:5px 12px;border-radius:100px;font-size:0.7rem;font-weight:600;background:var(--primary-light);color:var(--primary);}
    .legal-meta-badge svg{width:12px;height:12px;}
    .legal-meta-date{font-size:0.72rem;color:var(--text-dimmed);font-weight:500;}
    .legal-body h3{font-family:var(--font-display);font-size:0.95rem;font-weight:700;color:var(--text);margin:22px 0 8px;letter-spacing:-0.01em;text-align:left;}
    .legal-body h3:first-of-type{margin-top:0;}
    .legal-body p{font-size:0.84rem;color:var(--text-muted);line-height:1.7;margin-bottom:12px;text-align:left;}
    .legal-body ul{padding-left:20px;margin-bottom:12px;}
    .legal-body li{font-size:0.84rem;color:var(--text-muted);line-height:1.7;margin-bottom:6px;text-align:left;}
    .legal-body li::marker{color:var(--primary);}
    .legal-body strong{color:var(--text);font-weight:600;}
    .legal-body a{color:var(--primary);font-weight:600;text-decoration:none;}
    .legal-body a:hover{text-decoration:underline;}
    .legal-callout{display:flex;gap:12px;padding:14px 16px;border-radius:var(--radius-md);background:var(--primary-light);border:1px solid rgba(68,114,196,0.1);margin:16px 0;}
    .legal-callout svg{width:16px;height:16px;flex-shrink:0;color:var(--primary);margin-top:2px;}
    .legal-callout p{margin:0;font-size:0.82rem;color:#2C4A80;line-height:1.55;font-weight:500;}
    .legal-embed{background:transparent;}
    .legal-embed .legal-page{max-width:none;margin:0;padding:0;}
    .legal-embed .legal-shell{border:none;box-shadow:none;border-radius:0;}
    .legal-embed .legal-head{display:none;}
    .legal-embed .legal-body{padding:0;}
  `;

  return (
    <>
      <style>{legalStyles}</style>
      <div className={embedded ? 'legal-embed' : undefined}>
        <div className="legal-page">
          <div className="legal-shell">
            <div className="legal-head">
              <h1>Privacy Policy</h1>
            </div>
            <div className="legal-body">
              <div className="legal-meta">
                <span className="legal-meta-badge">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                    <path d="M7 11V7a5 5 0 0110 0v4" />
                  </svg>
                  Privacy
                </span>
                <span className="legal-meta-date">Effective: 1 March 2026</span>
              </div>

              <h3>1. Overview</h3>
              <p>
                This Privacy Policy explains how{' '}
                <strong>Ahedge People Services Pvt. Ltd.</strong> ("AHEDGE",
                "we", "us") collects, uses, shares, and protects your personal
                information when you use our platform. We are committed to
                transparency and safeguarding your data.
              </p>

              <h3>2. Information We Collect</h3>
              <p>
                <strong>a) Information you provide directly:</strong>
              </p>
              <ul>
                <li>
                  <strong>Account data</strong> — name, email address, phone
                  number, password, and linked sign-in methods (Google OAuth
                  tokens, OTP records).
                </li>
                <li>
                  <strong>Profile data</strong> — education history, work
                  experience, skills, certifications, resume/CV uploads, and
                  profile photo.
                </li>
                <li>
                  <strong>Assessment data</strong> — your responses, scores, and
                  completion status for skills assessments and micro-bootcamps.
                </li>
                <li>
                  <strong>Communications</strong> — messages you send through
                  the platform or to our support team.
                </li>
              </ul>
              <p>
                <strong>b) Information collected automatically:</strong>
              </p>
              <ul>
                <li>
                  <strong>Device &amp; browser data</strong> — IP address,
                  device type, operating system, browser type, and language
                  preferences.
                </li>
                <li>
                  <strong>Usage data</strong> — pages visited, features used,
                  session duration, click patterns, and referral sources.
                </li>
                <li>
                  <strong>Cookies &amp; tracking</strong> — session cookies for
                  authentication, analytics cookies (Google Analytics), and
                  optional preference cookies.
                </li>
              </ul>

              <h3>3. How We Use Your Information</h3>
              <ul>
                <li>
                  <strong>Service delivery</strong> — to create your account,
                  match you with roles, administer assessments, and deliver
                  bootcamp content.
                </li>
                <li>
                  <strong>Employer matching</strong> — sharing your profile
                  (name, skills, assessment scores) with prospective employers
                  only when you apply or opt in to matching.
                </li>
                <li>
                  <strong>Communications</strong> — sending you job alerts,
                  assessment reminders, platform updates, and security
                  notifications.
                </li>
                <li>
                  <strong>Improvement</strong> — analyzing aggregated,
                  anonymized usage data to improve our algorithms, content, and
                  user experience.
                </li>
                <li>
                  <strong>Legal compliance</strong> — fulfilling legal
                  obligations, enforcing our Terms, and protecting against
                  fraud.
                </li>
              </ul>

              <div className="legal-callout">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
                <p>
                  We will <strong>never</strong> sell your personal data to
                  third parties. Your profile is only shared with employers you
                  actively engage with.
                </p>
              </div>

              <h3>4. Data Sharing</h3>
              <p>We may share your information with:</p>
              <ul>
                <li>
                  <strong>Employer partners</strong> — only the profile data you
                  consent to share when applying for or being matched with a
                  role.
                </li>
                <li>
                  <strong>Service providers</strong> — hosting (AWS Mumbai
                  region), email delivery (Amazon SES), analytics (Google
                  Analytics), and payment processing (Razorpay) — all bound by
                  data processing agreements.
                </li>
                <li>
                  <strong>Legal authorities</strong> — when required by law,
                  court order, or governmental regulation.
                </li>
              </ul>

              <h3>5. Data Security</h3>
              <p>We implement industry-standard security measures including:</p>
              <ul>
                <li>TLS 1.3 encryption for all data in transit.</li>
                <li>AES-256 encryption for sensitive data at rest.</li>
                <li>
                  Passwords are hashed using bcrypt with per-user salts; we
                  never store plaintext passwords.
                </li>
                <li>Regular penetration testing and security audits.</li>
                <li>
                  Role-based access control with multi-factor authentication for
                  internal staff.
                </li>
              </ul>

              <h3>6. Data Retention</h3>
              <p>
                We retain your account and profile data for as long as your
                account is active. If you delete your account, we will erase or
                anonymize your personal data within <strong>30 days</strong>,
                except where retention is required by law (e.g., financial
                records retained for 7 years per Indian tax regulations).
              </p>

              <h3>7. Your Rights</h3>
              <p>Depending on your jurisdiction, you have the right to:</p>
              <ul>
                <li>
                  <strong>Access</strong> — request a copy of the personal data
                  we hold about you.
                </li>
                <li>
                  <strong>Correction</strong> — update or correct inaccurate
                  data via your profile settings or by contacting us.
                </li>
                <li>
                  <strong>Deletion</strong> — request deletion of your account
                  and personal data.
                </li>
                <li>
                  <strong>Portability</strong> — receive your data in a
                  structured, machine-readable format.
                </li>
                <li>
                  <strong>Withdraw consent</strong> — opt out of marketing
                  communications at any time.
                </li>
                <li>
                  <strong>Objection</strong> — object to processing based on
                  legitimate interests.
                </li>
              </ul>
              <p>
                To exercise any of these rights, contact us at{' '}
                <a href="mailto:privacy@ahedge.in">privacy@ahedge.in</a>. We
                will respond within 30 days.
              </p>

              <h3>8. Cookies &amp; Tracking</h3>
              <p>We use the following types of cookies:</p>
              <ul>
                <li>
                  <strong>Essential cookies</strong> — required for
                  authentication and core functionality (cannot be disabled).
                </li>
                <li>
                  <strong>Analytics cookies</strong> — help us understand usage
                  patterns (can be disabled in cookie settings).
                </li>
                <li>
                  <strong>Preference cookies</strong> — remember your language
                  and display settings.
                </li>
              </ul>
              <p>
                We do not use third-party advertising cookies or cross-site
                tracking pixels.
              </p>

              <h3>9. Children's Privacy</h3>
              <p>
                AHEDGE is not intended for individuals under 18 years of age. We
                do not knowingly collect personal information from minors. If we
                discover that a minor has created an account, we will promptly
                delete the account and associated data.
              </p>

              <h3>10. International Transfers</h3>
              <p>
                Your data is primarily stored in{' '}
                <strong>AWS Mumbai (ap-south-1)</strong>. If data is transferred
                outside India for processing (e.g., email delivery), we ensure
                appropriate safeguards are in place, including standard
                contractual clauses and data processing agreements.
              </p>

              <h3>11. Changes to This Policy</h3>
              <p>
                We may update this Privacy Policy from time to time. We will
                notify you of material changes via email or in-app notification
                at least 14 days before they take effect. The "Effective" date
                at the top reflects the most recent revision.
              </p>

              <h3>12. Grievance Officer</h3>
              <p>
                In accordance with the Information Technology Act, 2000, the
                Grievance Officer for AHEDGE is:
              </p>
              <p>
                <strong>Mr Amitabh Tewary</strong>
                <br />
                Head of Compliance, Ahedge People Services Pvt. Ltd.
                <br />
                Door No. 42/1234, Marine Drive
                <br />
                Ernakulam, Kochi — 682031, Kerala, India
                <br />
                Email:{' '}
                <a href="mailto:grievance@ahedge.in">grievance@ahedge.in</a>
                <br />
                Phone: +91 484 234 5679
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  const embeddedStyles = embedded
    ? `${styles
        .replace(/:root/g, '.pp-embed')
        .replace(/\bbody\b/g, '.pp-embed')}
        /* Embedded (modal) overrides */
        .pp-embed { background: transparent; color: var(--text-body); }
        .pp-embed .pp-page-wrapper { max-width: 100%; margin: 0; padding: 0; }
        .pp-embed .pp-hero { display: none; }
        .pp-embed .pp-footer-strip { display: none; }
        .pp-embed .pp-toc-bar { position: static; top: auto; padding: 12px 16px; border-top-left-radius: 12px; border-top-right-radius: 12px; }
        .pp-embed .pp-policy-body { padding: 16px 16px 22px; }
        @media (max-width: 600px) {
          .pp-embed .pp-toc-bar { padding: 10px 12px; }
          .pp-embed .pp-policy-body { padding: 14px 12px 18px; }
        }
      `
    : styles;

  return (
    <>
      <style>{embeddedStyles}</style>

      <div className={embedded ? 'pp-embed' : undefined}>
        <div className="pp-page-wrapper">
          {/* Hero */}
          <div className="pp-hero">
            <div className="pp-hero-icon">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L3 7v5c0 5.25 3.75 10.15 9 11.25C17.25 22.15 21 17.25 21 12V7l-9-5z" />
              </svg>
            </div>
            <div className="pp-hero-text !text-left">
              <h1>Privacy Policy</h1>
              <div className="pp-hero-meta">
                <span className="pp-meta-pill">
                  Stay Ahedge Private Limited
                </span>
                <span className="pp-meta-pill">Effective: 2024</span>
                <span className="pp-meta-pill">www.ahedge.in</span>
              </div>
            </div>
          </div>

          {/* Content Card */}
          <div className="pp-content-card">
            {/* TOC */}
            <div className="pp-toc-bar">
              <span className="pp-toc-label">Sections</span>
              <a href="#s1" className="pp-toc-link">
                1. Consent
              </a>
              <a href="#s2" className="pp-toc-link">
                2. Information Collected
              </a>
              <a href="#s3" className="pp-toc-link">
                3. Review &amp; Updates
              </a>
              <a href="#s4" className="pp-toc-link">
                4. Third-Party
              </a>
              <a href="#s5" className="pp-toc-link">
                5. Security
              </a>
              <a href="#s6" className="pp-toc-link">
                6. Cookies
              </a>
              <a href="#s7" className="pp-toc-link">
                7. Grievance
              </a>
            </div>

            <div className="pp-policy-body">
              {/* Intro */}
              <div className="text-sm pp-intro-clause">
                <p>
                  This privacy policy (<strong>"Privacy Policy"</strong>)
                  governs the use of information by{' '}
                  <strong>Stay Ahedge Private Limited</strong>, a company
                  incorporated under the Companies Act, 2013, with its
                  registered office at 1205 Rangsharda, Reclamation, Bandra
                  West, Mumbai, Maharashtra 400050 (hereinafter referred to as{' '}
                  <em>"Company"</em>, <em>"we"</em> or <em>"us"</em>) that is
                  obtained through the use of its website{' '}
                  <a
                    href="https://www.ahedge.in"
                    style={{ color: 'var(--accent)' }}
                  >
                    www.ahedge.in
                  </a>{' '}
                  (<em>"Website"</em>) by you (<em>"User"</em> or <em>"you"</em>
                  ).
                </p>
                <p style={{ marginTop: '10px' }}>
                  Please read the terms of this Privacy Policy in consonance
                  with the Company's{' '}
                  <a
                    href="https://www.ahedge.in/terms-of-use"
                    style={{ color: 'var(--accent)' }}
                  >
                    Terms of Use
                  </a>
                  .
                </p>
              </div>

              {/* Section 1 */}
              <div className="pp-section" id="s1">
                <div className="pp-section-header">
                  <div className="pp-section-number">1</div>
                  <h2 className="pp-section-title">Your Consent</h2>
                </div>

                <div className="pp-clause">
                  <div className="pp-clause-label">1.1 — Acceptance</div>
                  <p>
                    A prerequisite for obtaining access to the Website is the
                    acceptance of this Privacy Policy. It applies to all
                    individuals and entities that use the Website. You grant
                    your consent by:
                  </p>
                  <ul>
                    <li>Accessing the Website</li>
                    <li>Submitting any information to the Company</li>
                  </ul>
                </div>

                <div className="pp-clause">
                  <div className="pp-clause-label">1.2 — Communications</div>
                  <p>
                    As part of providing our products or services, we may need
                    to send routine communications through any means available,
                    including email, text, other forms of messaging or calls.
                    You agree to receive our phone calls or any other mode of
                    communication as deemed appropriate.
                  </p>
                </div>

                <div className="pp-clause">
                  <div className="pp-clause-label">
                    1.3 — Promotional Emails
                  </div>
                  <p>
                    When you provide your information on the Website, you also
                    consent to allowing us to periodically send emails. If you
                    do not wish to receive promotional information, you can opt
                    out at any time by following the process mentioned in the
                    promotional communication.
                  </p>
                </div>

                <div className="pp-clause">
                  <div className="pp-clause-label">
                    1.4 — No Third-Party Sharing
                  </div>
                  <p>
                    We do not share the information provided by you with any
                    other third party.
                  </p>
                </div>
              </div>

              <hr className="pp-section-divider" />

              {/* Section 2 */}
              <div className="pp-section" id="s2">
                <div className="pp-section-header">
                  <div className="pp-section-number">2</div>
                  <h2 className="pp-section-title">
                    Information Collected by the Company
                  </h2>
                </div>

                <div className="pp-clause">
                  <div className="pp-clause-label">2.1 — Data We Collect</div>
                  <p>
                    The Company only collects the following information on the
                    Website:
                  </p>
                  <ul>
                    <li>Name</li>
                    <li>Email</li>
                    <li>Phone Number</li>
                    <li>Company</li>
                  </ul>
                </div>

                <div className="pp-clause">
                  <div className="pp-clause-label">
                    2.2 — Optional Provision
                  </div>
                  <p>
                    There is no requirement for provision of any of the above
                    mentioned information for the use of the Website. The User
                    may provide the information only if they wish to raise a
                    query.
                  </p>
                </div>

                <div className="pp-clause">
                  <div className="pp-clause-label">
                    2.3 — Technical Information
                  </div>
                  <p>
                    During the use of the Website, we may automatically receive
                    technical information about your device, including your IP
                    address, operating system, time-zone, browser type and
                    browser plug-in details. When you browse our Website, we may
                    also collect information regarding pages viewed, web
                    addresses from which you arrive, time spent on certain
                    pages, download errors and page response times. All this
                    information helps us analyse user trends and preferences.
                  </p>
                </div>
              </div>

              <hr className="pp-section-divider" />

              {/* Section 3 */}
              <div className="pp-section" id="s3">
                <div className="pp-section-header">
                  <div className="pp-section-number">3</div>
                  <h2 className="pp-section-title">Review and Updates</h2>
                </div>

                <div className="pp-clause">
                  <div className="pp-clause-label">3.1 — Accuracy</div>
                  <p>
                    We regularly review and update our Privacy Policy, and we
                    request you to regularly review it. It is also important
                    that the information we hold about you is accurate and
                    current. Please keep us informed if your information
                    undergoes any change during your relationship with us. We
                    are not responsible for any inaccurate information you
                    provide.
                  </p>
                </div>

                <div className="pp-clause">
                  <div className="pp-clause-label">3.2 — Amendments</div>
                  <p>
                    We may update or amend this Privacy Policy at any time, with
                    or without advance notice. In the event there are
                    significant changes in the way the Company treats the User's
                    information, the Company will display a notice on the
                    Website.
                  </p>
                </div>
              </div>

              <hr className="pp-section-divider" />

              {/* Section 4 */}
              <div className="pp-section" id="s4">
                <div className="pp-section-header">
                  <div className="pp-section-number">4</div>
                  <h2 className="pp-section-title">Third-Party Services</h2>
                </div>

                <div className="pp-clause">
                  <div className="pp-clause-label">4.1 — External Links</div>
                  <p>
                    The Website may include links to third-party websites,
                    plug-ins, and applications. Clicking on those links or
                    enabling those connections may allow third parties to
                    collect or share data about you. We do not control these
                    third-party services and are not responsible for their
                    privacy statements. When you leave the Website or access
                    third-party links, we encourage you to read the privacy
                    policy of each such third-party service provider.
                  </p>
                </div>
              </div>

              <hr className="pp-section-divider" />

              {/* Section 5 */}
              <div className="pp-section" id="s5">
                <div className="pp-section-header">
                  <div className="pp-section-number">5</div>
                  <h2 className="pp-section-title">Security Policy</h2>
                </div>

                <div className="pp-clause">
                  <div className="pp-clause-label">5.1 — Security Measures</div>
                  <p>
                    The Company takes careful precautions to protect our Users'
                    information from unauthorised access, improper use or
                    disclosure or unauthorised modification. To prevent
                    unauthorised access, we have put in place industry-standard
                    security technology and procedures to safeguard the
                    information we collect online, including technical,
                    operational and physical security controls. Your information
                    will be accessed by Company personnel strictly on a need
                    basis.
                  </p>
                  <p style={{ marginTop: '10px' }}>
                    Even though we have taken significant steps to protect your
                    information, no company can fully eliminate security risks
                    associated with information. We disclaim any responsibility
                    for any intercepted information sent via the internet, and
                    you hereby release us from any and all claims arising out of
                    or related to the use of intercepted information in any
                    unauthorized manner.
                  </p>
                </div>
              </div>

              <hr className="pp-section-divider" />

              {/* Section 6 */}
              <div className="pp-section" id="s6">
                <div className="pp-section-header">
                  <div className="pp-section-number">6</div>
                  <h2 className="pp-section-title">Cookies</h2>
                </div>

                <div className="pp-clause">
                  <div className="pp-clause-label">6.1 — Cookie Usage</div>
                  <p>
                    The Website uses temporary cookies to store certain data
                    that is used by us for maintenance of the Website and its
                    features as well as research and development. We do not
                    store personally identifiable information in the cookies.
                  </p>
                </div>
              </div>

              <hr className="pp-section-divider" />

              {/* Section 7 */}
              <div className="pp-section" id="s7">
                <div className="pp-section-header">
                  <div className="pp-section-number">7</div>
                  <h2 className="pp-section-title">Grievance Officer</h2>
                </div>

                <div className="pp-clause" style={{ marginBottom: '16px' }}>
                  <div className="pp-clause-label">7.1 — Contact</div>
                  <p>
                    If you have any complaints, grievances or concerns with
                    respect to the Website or this Privacy Policy, please inform
                    such matters to the designated Grievance Officer in writing
                    or through electronic mail:
                  </p>
                </div>

                <div className="pp-contact-card">
                  <div className="pp-contact-avatar">SK</div>
                  <div className="pp-contact-info !text-left">
                    <div className="pp-name">Shreyas K</div>
                    <div className="pp-role">Lead, Business Solutions</div>
                    <a href="mailto:shreyas@ahedge.in">shreyas@ahedge.in</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer strip */}
          <div className="pp-footer-strip !justify-center">
            <p>
              © 2024 Stay Ahedge Private Limited · 1205 Rangsharda, Reclamation,
              Bandra West, Mumbai 400050
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
